import { useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag } from '../Generic'
import { useTranslation } from 'react-i18next'

export interface Auftrag3_20FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag3_20Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag3_20FormProps>) {
  const { control } = useFormContext()
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="3.20"
      label={t('auftraege.3_20.label')}
      fieldName="auftrag_3_20.enabled"
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.3_20.label')}</span>
    </BefehlFormAuftrag>
  )
}
